module.exports = __webpack_public_path__ + "static/media/app-bubbles.54d79cec.svg";